import { InjectionToken, inject } from '@angular/core';
import { ApiClient, injectApiClient } from '@open/ngx-api';
import { OnCallContracts } from '@assets/api/onCallContracts';

type BeneficiaryCalls = Pick<OnCallContracts,
  | 'AUTH-checkIsActivatedUser_onCall'
  | 'AUTH-createPinForUser_onCall'
  | 'AUTH-loginForUserWithPin_onCall'
  | 'BENEFICIARIES-getBeneficiaryEmployeeRecords_onCall'
  | 'BENEFICIARIES-getBeneficiaryQrCodeString_onCall'
  | 'BENEFICIARIES-getBeneficiarySubscription_onCall'
  | 'BENEFICIARIES-updateBeneficiaryOnboardingStatus_onCall'
  | 'DISCRETE_VOUCHERS-getBeneficiaryCreditLots_onCall'
  | 'DISCRETE_VOUCHERS-getBeneficiaryPruneoTransactions_onCall'
  | 'DISCRETE_VOUCHERS-getBeneficiaryVouchersInformations_onCall'
  | 'DISCRETE_VOUCHERS-listEligibleBusinessesOfBeneficiary_onCall'
>;

export type BeneficiaryApi = ApiClient<BeneficiaryCalls>;

// Token-backed so specs can `{ provide: BENEFICIARY_API, useValue: stub }`.
export const BENEFICIARY_API: InjectionToken<BeneficiaryApi> = new InjectionToken<BeneficiaryApi>('BENEFICIARY_API', {
  providedIn: 'root',
  factory: (): BeneficiaryApi => injectApiClient<BeneficiaryCalls>(),
});

export function injectApi(): BeneficiaryApi {
  return inject(BENEFICIARY_API);
}
